import { Preferences } from '@capacitor/preferences';

/** Legacy: was set before opening system UI, so it could be true even when the user never became default. */
const LEGACY_HAS_SEEN_KEY = 'hasSeenOnboarding';

const POLICY_VERSION_KEY = 'launcherOnboardingPolicyVersion';
const CURRENT_POLICY_VERSION = '2';

/** Set only when the user explicitly skips onboarding without becoming default. */
export const LAUNCHER_ONBOARDING_SKIPPED_KEY = 'launcherOnboardingSkipped';

/**
 * One-time migration: clear legacy `hasSeenOnboarding` so users stuck after the old bug see onboarding again.
 */
export async function migrateLauncherOnboardingPolicy(): Promise<void> {
  try {
    const { value } = await Preferences.get({ key: POLICY_VERSION_KEY });
    if (value === CURRENT_POLICY_VERSION) {
      return;
    }
    await Preferences.remove({ key: LEGACY_HAS_SEEN_KEY });
    await Preferences.set({ key: POLICY_VERSION_KEY, value: CURRENT_POLICY_VERSION });
  } catch {
    /* ignore */
  }
}

export async function isLauncherOnboardingSkipped(): Promise<boolean> {
  try {
    const { value } = await Preferences.get({ key: LAUNCHER_ONBOARDING_SKIPPED_KEY });
    return value === 'true';
  } catch {
    return false;
  }
}

export async function setLauncherOnboardingSkipped(): Promise<void> {
  await Preferences.set({ key: LAUNCHER_ONBOARDING_SKIPPED_KEY, value: 'true' });
}
